import React,{useState,useEffect} from 'react'
import clinicbookingService from '../../../../../services/clinicbooking.service'
import {toastify} from 'react-toastify'
import Loading from "../../../../common/Loading"
import DayHours from './DayHours'
import {toast} from 'react-toastify'

function DoctorHours({id,clinicid}) {
    const [isEditing,setIsEditing] = useState(false)
    const [bookingHours,setBookingHours] = useState([])
    const [updating,setUpdating] = useState(false)

    useEffect(()=>{
        getBookingHours()
    },[])
   
    useEffect(()=>{
       if(updating){
            serverUpdate()
            setUpdating(false)
       }
    },[updating])
    const getBookingHours = ()=>{
        clinicbookingService.getDoctorHours(clinicid,id)
        .then(res=>{
            setBookingHours(res.data)
        })
        .catch(err=>{
            console.log(err)
        })
    }
    const handleUpdate = (item)=>{
      
       setBookingHours(bookingHours.map((row)=>{
             return (row.id === item.id? item:row)
       }))
       setUpdating(true)
      // serverUpdate()
    }
    const serverUpdate = ()=>{
       
        clinicbookingService.updateDoctorHours(clinicid,id,bookingHours)
        .then(res=>{
            toast.success("Updated Hours",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
            getBookingHours()
        })
        .catch(err=>{
            toast.error("Error while updating Hours",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
        })
    }
    return (
    <>
        <hr/>
       
        <div className="d-flex justify-content-between">
                 <h4>Hours</h4>
        </div>
        <hr/>
        <div className="row mb-2">
            <div className="col-2 lable">Day</div>
            <div className="col-1 lable">isOff</div>
            <div className="col-2 lable">Start Time</div>
            <div className="col-2 lable">End TIme</div>
            <div className="col-2 lable">Lunch From</div>
            <div className="col-2 lable">Lunch To</div>
            <div className="col-1 lable">Action</div>
        </div>
        <hr/>
        {bookingHours.map((item,index)=>{
                            return (<DayHours hours={item} key={index} handleUpdate= {handleUpdate} />)
                        })}
        
    </>
  )
}

export default DoctorHours